/**
 * @generated SignedSource<<20728128eaadfd0bca70dcf0c4b7b773>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAutoNutritionInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type ClientAutoNutritionEntryHistoryItemDeleteMutation$variables = {
  input: DeleteAutoNutritionInput;
};
export type ClientAutoNutritionEntryHistoryItemDeleteMutation$data = {
  readonly deleteAutoNutrition: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type ClientAutoNutritionEntryHistoryItemDeleteMutation = {
  response: ClientAutoNutritionEntryHistoryItemDeleteMutation$data;
  variables: ClientAutoNutritionEntryHistoryItemDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAutoNutritionPayload",
    "kind": "LinkedField",
    "name": "deleteAutoNutrition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientAutoNutritionEntryHistoryItemDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientAutoNutritionEntryHistoryItemDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "22370d33c2fbef60bbcf50e8924bba70",
    "id": null,
    "metadata": {},
    "name": "ClientAutoNutritionEntryHistoryItemDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ClientAutoNutritionEntryHistoryItemDeleteMutation(\n  $input: DeleteAutoNutritionInput!\n) {\n  deleteAutoNutrition(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "135aa66dd8c43ef9e544c0f67611c996";

export default node;
